var map = {
	"./img_Characterdesign-Junior-01Champion_J07.png": 1214,
	"./img_Characterdesign-Junior-02Second_J12.png": 1215,
	"./img_Characterdesign-Junior-03Third_J04.png": 1216,
	"./img_Characterdesign-Junior-04Merit_Prize_J08.png": 1217,
	"./img_Characterdesign-Junior-05Merit_Prize_J13.png": 1218,
	"./img_Characterdesign-Junior-06Merit_Prize_J01.png": 1219,
	"./img_Characterdesign-Senior-01Champion_S01.png": 1220,
	"./img_Characterdesign-Senior-02Secornd_S02.png": 1221,
	"./img_Characterdesign-Senior-03Third_S11.png": 1222,
	"./img_Characterdesign-Senior-04Merit_Prize_S03.png": 1223,
	"./img_Characterdesign-Senior-05Merit_Prize_S06.png": 1224,
	"./img_Characterdesign-Senior-06Merit_Prize_S05.png": 1225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 309;